

















import { Component, Prop, Vue } from 'vue-property-decorator'
import request, { Response } from '@/helpers/requests'
import debug from '@/helpers/debug'
import js2excel from 'js2excel'
import { UserSearch } from './types/user-search'


interface ReportData<R> {
    rows: R[];
}


interface LoadReportResponse<R> extends Response {
    data: ReportData<R>;
}


@Component
export default class FacebookTable<R> extends Vue {
    @Prop() userSearch!: UserSearch
    // Report dependent properties.
    @Prop() headers!: number
    @Prop() loadReportUrl!: string
    @Prop() humanReadableReportName!: string
    @Prop() excelReportName!: string
    reportData: R[] = []
    search = ''
    loading = false

    /**
     * This functions retrieves the pertinent data for the report from the endpoint using accountId, fromDate, and
     * toDate.
     */
    async getReportData(): Promise<LoadReportResponse<R>> {
        return await request.post(`/support/franchise/${this.loadReportUrl}`, this.userSearch) as LoadReportResponse<R>
    }

    async compileData() {
        this.loading = true
        const data = await this.getReportData()
        this.reportData = data.data.rows
        this.loading = false
    }

    /**
     * This function is responsible for the exporting of the data from the report to an excel sheet.
     * NOTE: This arranges the columns in a strange way. It sorts columns in alphabetical order.
     * These file names may also not exceed 31 characters.
     */
    exportToExcel() {
        const reportName = this.excelReportName
        const data = this.reportData
        const date = new Date().toISOString().slice(0, 10)
        const name = reportName.concat('_' + date)
        try {
            js2excel.json2excel({
                data,
                name,
                formateDate: 'yyyy/mm/dd'
            })
        } catch(e) {
            debug.error('Excel export error')
        }
    }
}
